export default __webpack_public_path__ + "images/8c2d46d8a725bbbb1fd1dd6b607d007c-adoption-cat-670.gif";